module.exports = __webpack_public_path__ + "static/media/400007_01.59b29496.png";